import { Component, inject, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ConsentService } from '@kp/tiia-services/consent';

import { ConsentConfigComponent } from './consent/config.component';
import { ConsentComponent } from './consent/consent.component';
import { LoadingComponent } from './loading/loading.component';

@Component({
  selector: 'kp-root',
  encapsulation: ViewEncapsulation.None,
  template:
    '<router-outlet />' +
    '<kp-loading />' +
    '@defer (when consentService.showConsent()){' +
    '@if (consentService.showConsent()){' +
    '<kp-consent />' +
    '}}' +
    '@defer (when consentService.showConfig()){' +
    '@if (consentService.showConfig()){' +
    '<kp-consent-config />' +
    '}}',
  imports: [
    ConsentComponent,
    ConsentConfigComponent,
    LoadingComponent,
    RouterOutlet,
  ],
  providers: [ConsentService],
})
export class AppComponent {
  readonly consentService = inject(ConsentService);
}
